import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import Button from 'modules/common/components/Button';
import { Spinner } from 'modules/common/components';
// import {
//   SummaryItem,
//   SummaryTitle,
//   SummaryCount,
//   LoaderWrapper,
//   SummaryIcon
// } from '../styles';
import { colors } from 'modules/common/styles';
import {
  SmsStatusDiv,
  LoaderWrapper,
  SummaryCount,
  SummaryItem,
  SummaryTitle
} from '../styles/main';
const propTypes = {
  data: PropTypes.array.isRequired,
  loading: PropTypes.bool
};

class DashboardTileTheme extends React.Component {
  renderSummary(sum) {
    return (
      <SmsStatusDiv
        key={Math.random()}
      >
        <SummaryItem>
          <i>{sum.icon}</i>
          {/* <SummaryIcon>{sum.icon}</SummaryIcon> */}
          <SummaryCount>{sum.count} </SummaryCount>{' '}
          {sum.isSecs && sum.isSecs === true && <span>{'sec'}</span>}
          <SummaryTitle>{sum.title}</SummaryTitle>
          {/* <div className="progress">
            <div className="progress-bar" role="progressbar"></div>
          </div> */}
        </SummaryItem>
      </SmsStatusDiv>
    );
  }

  render() {
    const { data, loading } = this.props;

    if (loading) {
      return (
        <LoaderWrapper>
          <Spinner objective />
        </LoaderWrapper>
      );
    }

    return (
      <React.Fragment>
        {data.map(detail => this.renderSummary(detail))}
      </React.Fragment>
    
    );
  }
}

DashboardTileTheme.propTypes = propTypes;

export default DashboardTileTheme;



// WEBPACK FOOTER //
// ./src/modules/theme/theme1/common/components/DashboardTileTheme.js